import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { text: String }

  copyText(_event) {
    this.element.dataset.copied = ''

    // Reset the timer if the swatch has been copied multiple times in quick succession
    if (this.element.copiedTimer) clearTimeout(this.element.copiedTimer)

    // Set a timer to hide the "Copied!" text after 2 seconds
    const copiedTimer = setTimeout(() => {
      this.element.removeAttribute('data-copied')
    }, 2000)

    // Attach the timer to the swatch
    if (!this.element.copiedTimer) this.element.copiedTimer = copiedTimer

    navigator.clipboard.writeText(this.textValue)
  }
}
